import React from 'react';
import { Navigate } from 'react-router-dom';
import { CONTATO_EMPRESTIMO } from '../../../../common/utils/paths';

export const SimulacaoEmprestimo = () => {
  return <Navigate to={CONTATO_EMPRESTIMO} state={{ emprestimo: true }} />;
};
